module.exports = __webpack_public_path__ + "static/media/biohazard.45c43073.svg";